<form *ngIf="form" [formGroup]="form">
  <div class="form-modal">
    <h1 mat-dialog-title>{{'FILTERS'|translate}}</h1>
    <div mat-dialog-content>
      <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-12 no-padding">
          <!-- produto -->
          <div class="col-lg-12 col-md-12 col-sm-12">

            <mat-form-field class="allwidth">
              <mat-select placeholder="{{'FROM_STATE'|translate}}" formControlName="FromStateID">
                <mat-option>
                  <ngx-mat-select-search formControlName="FromStateIDFilter" [placeholderLabel]="'SEARCH'|translate"
                    [noEntriesFoundLabel]="'NO_RESULTS_WERE_FOUND'|translate">
                    <i class="fas fa-times" ngxMatSelectSearchClear></i>
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option> </mat-option>
                <mat-option *ngFor="let state of filteredFromStatesList | async"
                  [value]="state.ID">{{state.Name ? state.Name : state.Description}}</mat-option>
              </mat-select>
            </mat-form-field>



            <mat-form-field class="allwidth">
              <mat-select placeholder="{{'TO_STATE'|translate}}" formControlName="ToStateID">
                <mat-option>
                  <ngx-mat-select-search formControlName="ToStateIDFilter" [placeholderLabel]="'SEARCH'|translate"
                    [noEntriesFoundLabel]="'NO_RESULTS_WERE_FOUND'|translate">
                    <i class="fas fa-times" ngxMatSelectSearchClear></i>
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option> </mat-option>
                <mat-option *ngFor="let state of filteredToStatesList | async"
                  [value]="state.ID">{{state.Name ? state.Name : state.Description}}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Nome Ação -->
            <mat-form-field class="allwidth">
              <input matInput placeholder="{{'ACTION_NAME' | translate}}" type="text" formControlName="ActionVerb">
            </mat-form-field>

            <!-- Limite mínimo -->
            <mat-form-field class="allwidth">
              <input matInput placeholder="Desde (€)" type="number" formControlName="MinimumLimit">
            </mat-form-field>

            <!-- Limite máximo -->
            <mat-form-field class="allwidth">
              <input matInput placeholder="Até (€)" type="number" formControlName="MaximumLimit">
            </mat-form-field>


            <mat-form-field class="allwidth">

              <mat-select placeholder="{{'COSTCENTER' | translate}}" formControlName="CostCenterID">
                <mat-option>
                  <ngx-mat-select-search formControlName="CostCenterIDFilter" [placeholderLabel]="'SEARCH'|translate"
                    [noEntriesFoundLabel]="'NO_RESULTS_WERE_FOUND'|translate">
                    <i class="fas fa-times" ngxMatSelectSearchClear></i>
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option> </mat-option>
                <mat-option *ngFor="let costCenter of filteredCostCentersList | async"
                  [value]="costCenter.ID">{{costCenter.Name}}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="allwidth" *ngIf="userGroupsList?.length > 0">
              <mat-select placeholder="{{'DEPARTMENT' | translate}}" formControlName="UserGroupID">
                <mat-option>
                  <ngx-mat-select-search formControlName="UserGroupIDFilter" [placeholderLabel]="'SEARCH'|translate"
                    [noEntriesFoundLabel]="'NO_RESULTS_WERE_FOUND'|translate">
                    <i class="fas fa-times" ngxMatSelectSearchClear></i>
                  </ngx-mat-select-search>
                </mat-option>
                <mat-option> </mat-option>
                <mat-option *ngFor="let usergroup of filteredUserGroupsList | async"
                  [value]="usergroup.ID">{{usergroup.Name}}</mat-option>
              </mat-select>
            </mat-form-field>





          </div>

          <div class="col-lg-12 col-md-12 col-sm-12 spacer-bottom-xs"></div>
        </div>




             <!-- Panel da Tabela de Criadores -->
             <div class="col-lg-4" *ngIf="showCreationPopup">
              <div class="panel panel-default">
                <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup1"
                  (click)="collPnPopup1 = !collPnPopup1">
                  <h5 class="panel-title">
                    <i class="fas fa-users"></i>
                    <strong> {{'CREATION'|translate}}</strong>
                    <i class="collapse-icon fas"
                      [ngClass]="{'fa-caret-down': collPnPopup1, 'fa-caret-up': !collPnPopup1}"></i>
                  </h5>
                </div>
                <div id="collPnPopup1" class="panel-body no-horizontal-padding collapse in">
                  <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup2"
                    (click)="collPnPopup2 = !collPnPopup2">
                    <h5 class="panel-title">
                      <i class="fas fa-users"></i>
                      <strong> {{'PROFILES'|translate}}</strong>
                      <i class="collapse-icon fas"
                        [ngClass]="{'fa-caret-down': collPnPopup2, 'fa-caret-up': !collPnPopup2}"></i>
                    </h5>
                  </div>
                  <div id="collPnPopup2" class="panel-body no-horizontal-padding collapse">
                    <table id="tabelaCreatorsRoles" class="table table-bordered display" cellspacing="0">
                      <thead>
                        <tr>
                          <th>
                            <strong>{{ 'NAME'| translate}}</strong>
                          </th>
                          <th></th>
                        </tr>
                        <tr>
                          <th>
                            <mat-form-field class="full-width findInputContainer">
                              <input type="text" matInput placeholder="{{'FILTER'|translate}}" class="findInput">
                            </mat-form-field>
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>

                  <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup3"
                    (click)="collPnPopup3 = !collPnPopup3">
                    <h5 class="panel-title">
                      <i class="fas fa-users"></i>
                      <strong> {{'USERS'|translate}}</strong>
                      <i class="collapse-icon fas"
                        [ngClass]="{'fa-caret-down': collPnPopup3, 'fa-caret-up': !collPnPopup3}"></i>
                    </h5>
                  </div>
                  <div id="collPnPopup3" class="panel-body no-horizontal-padding collapse">
                    <table id="tabelaCreatorsUsers" class="table table-bordered display" cellspacing="0">
                      <thead>
                        <tr>
                          <th>
                            <strong>{{ 'NAME'| translate}}</strong>
                          </th>
                          <th></th>
                        </tr>
                        <tr>
                          <th>
                            <mat-form-field class="full-width findInputContainer">
                              <input type="text" matInput placeholder="{{'FILTER'|translate}}" class="findInput">
                            </mat-form-field>
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>

            <!-- Panel da Tabela de Aprovadores -->
            <div [ngClass]="{'col-lg-4' : showCreationPopup, 'col-lg-8' : !showCreationPopup}">
              <div class="panel panel-default">
                <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup4"
                  (click)="collPnPopup4 = !collPnPopup4">
                  <h5 class="panel-title">
                    <i class="fas fa-users"></i>
                    <strong> {{'APPROVATION'|translate}}</strong>
                    <i class="collapse-icon fas"
                      [ngClass]="{'fa-caret-down': collPnPopup4, 'fa-caret-up': !collPnPopup4}"></i>
                  </h5>
                </div>
                <div id="collPnPopup4" class="panel-body no-horizontal-padding collapse in">
                  <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup5"
                    (click)="collPnPopup5 = !collPnPopup5">
                    <h5 class="panel-title">
                      <i class="fas fa-users"></i>
                      <strong> {{'PROFILES'|translate}}</strong>
                      <i class="collapse-icon fas"
                        [ngClass]="{'fa-caret-down': collPnPopup5, 'fa-caret-up': !collPnPopup5}"></i>
                    </h5>
                  </div>
                  <div id="collPnPopup5" class="panel-body no-horizontal-padding collapse">
                    <table id="tableAproversRoles" class="table table-bordered display" cellspacing="0">
                      <thead>
                        <tr>
                          <th>
                            <strong>{{ 'NAME'| translate}}</strong>
                          </th>
                          <th></th>
                        </tr>
                        <tr>
                          <th>
                            <mat-form-field class="full-width findInputContainer">
                              <input type="text" matInput placeholder="{{'FILTER'|translate}}" class="findInput">
                            </mat-form-field>
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>

                  <div class="panel-heading clearfix pointer" data-toggle="collapse" data-target="#collPnPopup6"
                    (click)="collPnPopup6 = !collPnPopup6">
                    <h5 class="panel-title">
                      <i class="fas fa-users"></i>
                      <strong> {{'USERS'|translate}}</strong>
                      <i class="collapse-icon fas"
                        [ngClass]="{'fa-caret-down': collPnPopup6, 'fa-caret-up': !collPnPopup6}"></i>
                    </h5>
                  </div>
                  <div id="collPnPopup6" class="panel-body no-horizontal-padding collapse">
                    <table id="tableAproversUsers" class="table table-bordered display" cellspacing="0">
                      <thead>
                        <tr>
                          <th>
                            <strong>{{ 'NAME'| translate}}</strong>
                          </th>
                          <th></th>
                        </tr>
                        <tr>
                          <th>
                            <mat-form-field class="full-width findInputContainer">
                              <input type="text" matInput placeholder="{{'FILTER'|translate}}" class="findInput">
                            </mat-form-field>
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>
      </div>

    </div>
    <div mat-dialog-actions>
      <div class="full-width text-right modal-theme">
        <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}"
          (click)="dialogRef.close(null)">
          {{'BUTTON.CANCEL' | translate}}
        </button>
        <button type="button" class="btn btn-primary" title="{{'BUTTON.OK' | translate}}"
          (click)="dialogRef.close({form: form, usersAproversSelected: usersAproversSelected, rolesAproversSelected: rolesAproversSelected,
            rolesCreatorsSelected: rolesCreatorsSelected, usersCreatorsSelected: usersCreatorsSelected})">
          {{'BUTTON.OK' | translate}}
        </button>
      </div>
    </div>
  </div>
</form>